<template>
  <div>
    <router-view></router-view>
    <loading-screen v-if="loading !== 0" :loading="loading"> </loading-screen>
  </div>
</template>

<script>
import api from './api/api.js';
import services from '@/api/services';
import LoadingScreen from '@/components/LoadingScreen.vue';
export default {
  components: {
    LoadingScreen,
  },
  data() {
    return {
      loading: 0,
      user: {},
    };
  },
  methods: {
    redirectIfLoggedOut() {
      api
        .get(services.getSession, { getSession: true })
        .then(data => {
          if (
            !data.user &&
            !window.location.href.match(/login$/) &&
            this.$route.name !== 'Register'
          ) {
            this.user = {};
            window.location.href = '/login';
          }
          if (data.user && window.location.href.match(/login$/)) {
            window.location.href = '/files?filter=confirmed';
          }
          this.user = data.user;
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    handleLoading() {
      this.loading++;
    },
    handleNotLoading() {
      this.loading--;
    },
  },
  beforeMount() {
    document.title =
      this.$route.meta.title + ' - WebToPrint' || 'WebToPrint - Studio Mouse';
    this.redirectIfLoggedOut();
  },
  created() {
    window.addEventListener('loading', this.handleLoading);
    window.addEventListener('notLoading', this.handleNotLoading);
  },
  destroyed() {
    window.removeEventListener('loading', this.handleLoading);
    window.removeEventListener('notLoading', this.handleNotLoading);
  },
  watch: {
    $route: {
      handler(to) {
        document.title =
          to.meta.title + ' - WebToPrint' || 'WebToPrint - Studio Mouse';
        if (!this.user) this.redirectIfLoggedOut();
      },
    },
  },
};
</script>

<style>
.invoice-prompt {
  text-align: end !important;
  padding-right: 6em;
}
.additional-fields {
  border: 1px solid #8b8b8b;
  border-radius: 0.5em;
  box-shadow: 0px 0px 2px 2px #8b8b8b;
  padding-bottom: 2em;
  margin: 1em 3.5em auto 3.5em;
  /* max-width: max-content; */
}
</style>
